import { BrowserRouter } from 'react-router-dom';
import { Provider } from "react-redux";
import ReduxToastr from 'react-redux-toastr';

import store from './client/js/store/store';
import routes from "./client/js/router/AppRoutes";
import HeadParams from './client/js/component/common/HeadParams';

const App = () => {
    return (
        <Provider store={store}>
            <div>
                <HeadParams />
                <BrowserRouter>
                    {routes}
                </BrowserRouter>
                <ReduxToastr
                    timeOut={5000}
                    newestOnTop={false}
                    preventDuplicates
                    position="top-right"
                    transitionIn="fadeIn"
                    transitionOut="fadeOut"
                />
            </div>
        </Provider>
    )
}

export default App;
